














import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class CompanyName extends Slide {
  get name() {
    return this.overview.NAME;
  }
}
